'use strict'

module.exports = {
  drain: require('./drain'),
  onEnd: require('./on-end'),
  log: require('./log'),
  find: require('./find'),
  reduce: require('./reduce'),
  collect: require('./collect'),
  concat: require('./concat')
}




//////////////////
// WEBPACK FOOTER
// ./~/pull-stream/sinks/index.js
// module id = 774
// module chunks = 0